<template>
  <div class="ag-radio-button">
    <v-radio-group
      v-model="localValue"
      color="primary"
      :hide-details="hideDetails"
      :inline="inline"
      :label="label"
      :rules="rules"
      @update:model-value="onUpdate"
    >
      <v-radio v-for="(item, key) in items" :key="key" :label="getItemTitle(item)" :value="getItemValue(item)" />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [String, Number, Boolean, null],
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    itemTitle: {
      type: [String, Function],
      default: 'title',
    },
    itemValue: {
      type: [String, Function],
      default: 'value',
    },
    hideDetails: {
      type: [String, Boolean],
      default: 'auto',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    getItemTitleKey() {
      return typeof this.itemTitle === 'function' ? this.itemTitle() : this.itemTitle;
    },
    getItemValueKey() {
      return typeof this.itemValue === 'function' ? this.itemValue() : this.itemValue;
    },
    getItemTitle(item) {
      return item[this.getItemTitleKey()];
    },
    getItemValue(item) {
      return item[this.getItemValueKey()];
    },
    onUpdate(val) {
      this.$emit('update:modelValue', val);
    },
  },
};
</script>

<style scoped lang="scss">
.ag-radio-button {
  ::v-deep(.v-radio-group) {
    > .v-input__control {
      > .v-label {
        margin-inline-start: 0;
        color: black;
        opacity: 1;

        + .v-selection-control-group {
          padding-inline-start: 0;

          .v-selection-control {
            .v-selection-control__wrapper .v-selection-control__input .v-icon {
              color: $brand-color-primary-medium;
              opacity: 1;
            }
            .v-label {
              color: black;
              opacity: 1;
            }
          }
        }

        + .v-selection-control-group--inline {
          gap: 12px;
        }
        .v-selection-control {
          .v-selection-control__wrapper .v-selection-control__input .v-icon {
            color: $brand-color-primary-medium;
            opacity: 1;
          }
          .v-label {
            color: black;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
